import dayjs from "@/lib/dayjs";

/**
 * 引数の日付が現在時刻から指定日数以内かどうか
 */
export function isWithinDays(date: string, days: number): boolean {
	return dayjs().diff(dayjs(date), "day") < days;
}
